import { render, staticRenderFns } from "./privatesms.vue?vue&type=template&id=28056d8f&scoped=true"
import script from "./privatesms.vue?vue&type=script&lang=js"
export * from "./privatesms.vue?vue&type=script&lang=js"
import style0 from "./privatesms.vue?vue&type=style&index=0&id=28056d8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28056d8f",
  null
  
)

export default component.exports